// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"3297cf9d","209":"e1f55257","248":"6ef05732","271":"20f9ef6f","478":"148e41f0","562":"9cd1dcb9","625":"78723a19","745":"b5c83463","922":"a9748d02","964":"763e6f1c"}[chunkId] + ".chunk.js";
};